import { MatrixAnswer } from './MatrixAnswer';

/**
 Class representing a question answer.
 */
export class QuestionAnswer {
    /**
     * Create a question answer.
     * @param {Object} questionAnswer - The question answer
     * @param {Number} questionAnswer.questionId - The id of the question.
     * @param {string} questionAnswer.text - The text answer if the question type is 'OpenAnswer'.
     * @param {string} questionAnswer.answer - The answer for 'YesNo' question, should be 'yes' or 'no'.
     * @param {Array<Number>} questionAnswer.alternativeIds - The selected alternativeIds, used for 'MultipleChoice'.
     * @param {Array<MatrixAnswer>} questionAnswer.matrixAnswers - The selected matrix answers, used for 'Matrix' questions.
     */
    constructor(questionAnswer) {
        this.questionId = questionAnswer.questionId;
        this.text = questionAnswer.text || '';
        this.answer = questionAnswer.answer || null;
        this.alternativeIds = questionAnswer.alternativeIds ? questionAnswer.alternativeIds : [];
        this.matrixAnswers = questionAnswer.matrixAnswers ? questionAnswer.matrixAnswers.map(m => new MatrixAnswer(m)) : [];
    }

    isAnswered() {
        return this.text !== '' || this.answer != null || this.alternativeIds.length > 0 || this.matrixAnswers.length > 0;
    }
}
